import { NgModule } from '@angular/core';
import { ColumnTypeIconModule } from './column-type-icon/column-type-icon.module';
import { ColumnTypeCssStylesDirective } from './column-type-css-styles.directive';

@NgModule({
  declarations: [ColumnTypeCssStylesDirective],
  exports: [ColumnTypeIconModule, ColumnTypeCssStylesDirective],
})
export class ColumnTypeModule {}
